import { Waves, MoveRight, Wind } from "lucide-react";

export default function Legend({ mode }) {
  return (
    <div className="glass pointer-events-none absolute bottom-3 left-3 z-20 rounded-lg px-3 py-2" data-testid="map-legend">
      <div className="eyebrow mb-1.5 text-slate-400">Legend</div>
      <div className="space-y-1.5 text-[11px] text-slate-300">
        <div className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full" style={{ background: "#00ff87", boxShadow: "0 0 8px #00ff87" }} />
          Sargassum biomass
        </div>
        <div className="flex items-center gap-2">
          <span className="relative inline-flex h-2 w-6 items-center">
            <span className="h-0.5 w-full rounded" style={{ background: "linear-gradient(90deg,#FF9F1C,#00ff87)" }} />
            <MoveRight className="absolute -right-1 h-3 w-3 text-amberx" />
          </span>
          48-h drift → coast
        </div>
        <div className="flex items-center gap-2">
          <Wind className="h-3 w-3 text-cyanx" />
          {mode === "flow" ? "Wind / current flow" : mode === "ocean" ? "Live drift (currents + wind)" : "Trade-wind field"}
        </div>
      </div>
    </div>
  );
}
